module.exports = __webpack_public_path__ + "static/img/img3.334b876.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product/338/carousel/c03/img3.png
// module id = MfyP
// module chunks = 0